import React, { useRef, useState } from "react";
import { Column, MasterDetail, Button } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../../Componentes/Basicos/LVGridCabecera";
import { PaginaListadoMaestros } from "../../../Componentes/Compuestos/Paginas/PaginaListadoMaestros";
import ABM_IMP_PuntosFiscales_Detalle from "./ABM_IMP_PuntosFiscales_Detalle";
import LVButtonAgregar from "../../../Componentes/Basicos/LVButtonAgregar";

export const ABM_IMP_PuntosFiscales_ = () => {
  const [data, setData] = useState([])
  const { ABM_IMP_PuntosFiscales: { function_ABM_IMP_PuntosFiscales_Listar } } = require('neftis7_apicaller');
  const refRecargaListado = useRef(null);

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const onClickDelete = (e) => {
    const Item = { ...e.row.data };
    if (window.confirm('¿Está seguro que desea eliminar este registro?')) {
      
      const setData = async () => {
        try {
          //await function_NOEXISTE(Item.IdDocVenta)
          refRecargaListado.current?.(); 
        } catch (error) {
          alert(error);
        }
      }
      setData();
    }
  };

  return (
    <PaginaListadoMaestros
      Titulo="PUNTOS DE VENTA FISCAL"
      funcion={function_ABM_IMP_PuntosFiscales_Listar}
      onDataLoaded={handleDataLoaded}
      refRecarga={refRecargaListado}
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonAgregar Url="/ABM_IMP_PuntosFiscales_ModificacionCreacion/--NUEVO--/--NUEVO--/--NUEVO--" />
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            id="gridContainer"
            keyExpr="CodigoPuntoFiscal"
            keyExpr2="IdTipoMovimiento"
            keyExpr3="IdTipo"
            urlEdicion="/ABM_IMP_PuntosFiscales_ModificacionCreacion"
            AnchoBotonera="65"
          >
            <Column type="buttons" name="Eliminar" width={40}>
              <Button name="Eliminar" icon="trash" onClick={onClickDelete} visible={false} />
            </Column>

            <Column caption="Código" dataField="CodigoPuntoFiscal" width="80" alignment="Left" dataType="string" />
            <Column caption="Cód.Movimiento" dataField="IdTipoMovimiento" width="100" alignment="Right" dataType="number" visible={false} />
            <Column caption="Movimiento" dataField="TipoMovimiento" width="100%" minWidth="200" alignment="Left" dataType="string" />
            <Column caption="Cód.Tipo" dataField="IdTipo" width="100" alignment="Right" dataType="number" visible={false} />
            <Column caption="Tipo" dataField="Tipo" minWidth="150" alignment="Left" dataType="string" />
            <Column caption="Terminal" dataField="Terminal" minWidth="90" alignment="Left" dataType="string" />
            <Column caption="C.U.I.T." dataField="CUIT" minWidth="120" alignment="Left" dataType="string" />
            <Column caption="L. Precios" dataField="CodigoListaPrecios" minWidth="110" alignment="Left" dataType="string" />
            <Column caption="Ubicación" dataField="CodigoUbicacionPredeterminada" minWidth="150" alignment="Left" dataType="string" />

            <Column caption="Electrónico" dataField="EsElectronico" width="100" alignment="Center" dataType="boolean" />

            <Column caption="Fiscal" alignment="Center">
              <Column caption="Razón Social" dataField="Fiscal_RazonSocial" minWidth="150" alignment="Left" dataType="string" />
              <Column caption="C.U.I.T." dataField="Fiscal_CUIT" minWidth="120" alignment="Left" dataType="string" />
              <Column caption="Domicilio" dataField="Fiscal_Domicilio" minWidth="100" alignment="Left" dataType="string" />
              <Column caption="Teléfono" dataField="Fiscal_Telefono" minWidth="100" alignment="Left" dataType="string" />
              <Column caption="E-Mail" dataField="Fiscal_Email" minWidth="100" alignment="Left" dataType="string" />
              <Column caption="Web" dataField="Fiscal_Web" minWidth="100" alignment="Left" dataType="string" />
            </Column>

            <MasterDetail
              enabled={true}
              component={ABM_IMP_PuntosFiscales_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListadoMaestros>
  );
};
